import React from 'react';
import Icon from '../../../primitives/Icon';
import { Circle, Ellipse } from 'react-native-svg';

export function MultiColorDotted(props: any) {
  return (
    <Icon color={props.color} viewBox="0 0 74.072 74.072" size={props.size}>
      <Circle
        id="Ellipse_24"
        data-name="Ellipse 24"
        cx="7.622"
        cy="7.622"
        r="7.622"
        transform="translate(7.037 48.382)"
        fillOpacity="0.7"
      />
      <Ellipse
        id="Ellipse_25"
        data-name="Ellipse 25"
        cx="6.628"
        cy="6.959"
        rx="6.628"
        ry="6.959"
        transform="translate(58.733 43.08)"
        fillOpacity="0.4"
      />
      <Circle
        id="Ellipse_26"
        data-name="Ellipse 26"
        cx="5.634"
        cy="5.634"
        r="5.634"
        transform="translate(53.431 11.267)"
        fillOpacity="0.2"
      />
      <Ellipse
        id="Ellipse_27"
        data-name="Ellipse 27"
        cx="8.383"
        cy="8.178"
        rx="8.383"
        ry="8.178"
        transform="translate(0 28.299)"
        fillOpacity="0.8"
      />
      <Ellipse
        id="Ellipse_28"
        data-name="Ellipse 28"
        cx="7.621"
        cy="7.426"
        rx="7.621"
        ry="7.426"
        transform="translate(24.843 59.221)"
        fillOpacity="0.6"
      />
      <Ellipse
        id="Ellipse_29"
        data-name="Ellipse 29"
        cx="7.24"
        cy="7.049"
        rx="7.24"
        ry="7.049"
        transform="translate(44.809 56.721)"
        fillOpacity="0.5"
      />
      <Ellipse
        id="Ellipse_30"
        data-name="Ellipse 30"
        cx="8.764"
        cy="8.554"
        rx="8.764"
        ry="8.554"
        transform="translate(8.688 8.554)"
        fillOpacity="0.9"
      />
      <Ellipse
        id="Ellipse_31"
        data-name="Ellipse 31"
        cx="6.478"
        cy="6.357"
        rx="6.478"
        ry="6.357"
        transform="translate(61.117 25.906)"
        fillOpacity="0.3"
      />
      <Ellipse
        id="Ellipse_32"
        data-name="Ellipse 32"
        cx="8.947"
        cy="9.279"
        rx="8.947"
        ry="9.279"
        transform="translate(30.234)"
        fillOpacity="1"
      />
    </Icon>
  );
}
